module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAt0lEQVRIx2P4ouVII8SAzPmeUPhr4eofeXVfTb2/6LpQzehfUxf8////R1EjkP3VxOv32m1fzX2oYPS30PT///79OXLqi67zN7/ELzpO3+Pyv+iB2brOFBn9s3cm0Mk/+2cD3fvn4IkvRh4gcX3XP/uOfrUOoI7RUAk9V4jRVA0QINs7/tfS9cAw+TV3xbfQDGpG41dz32/ecaDIdIv6ahtEg8RH3XRN5Szzn2Zg1OhRo0eNJgkAAPmQOlRpchmGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sg.png
// module id = 924
// module chunks = 0